import React, {useEffect} from 'react';
import {useDispatch, useSelector} from "react-redux";
import toast, {Toaster} from "react-hot-toast";
import {useLocation} from "react-router-dom";

import styles from './SearchCleanerPage.module.scss';
import {stepperInfoActions} from "../../store/slices/stepperInfoSlice";
import TriangleStepper from "../../components/TriangleStepper/TriangleStepper";
import CleanerBioShort from "../../components/CleanerBioShort/CleanerBioShort";
import {orderingByCustomer} from "../../constants/orderingByCustomer";
import EmptyState from "../EmptyState/EmptyState";
import SearchBar from "../../components/SearchBar/SearchBar";
import {cleanerApplicationsActions} from "../../store/slices/cleanerApplicationsSlice";
import emptyCleanerApplications from '../../constants/images/detailsOrder/waiting.svg';
import emptyFilteredItems from '../../constants/images/no-results-filter.svg';
import Loader from "../../components/Loader/Loader";

const SearchCleanerPage = ({currentStep, setCurrentStep, isOrder}) => {
    const {pathname} = useLocation();
    const array = pathname.split('/');

    let id;
    if (pathname.endsWith('/')) {
        id = array[array.length - 2];
    } else {
        id = array[array.length - 1];
    }

    const dispatch = useDispatch();
    const {min_price, max_price, ordering, trigger, searchValue} = useSelector(state => state.filtersForCustomer);
    const {status, cleanerApplicationsByCleaningRequest} = useSelector(state => state.cleanerApplications);


    useEffect(() => {
        dispatch(stepperInfoActions.setTypeSorting(orderingByCustomer[0]));
    }, []);
    const getFilteredCleanerApplications = async (id, params) => {
        try {
            await dispatch(cleanerApplicationsActions.getFilteredByCleanerRequest({id, params}));
        } catch (error) {
            console.error(error);
        }
    }
    useEffect(() => {
        const params = {min_price, max_price, ordering, search: searchValue};
        getFilteredCleanerApplications(id, params);
    }, [ordering, trigger]);


    useEffect(() => {
        if (!(max_price || min_price || ordering || searchValue)) {
            getFilteredCleanerApplications(id, {});
        }
    }, []);


    return (
        (status === "loading") ?
            <Loader/> :
            <div className={styles.searchCleanerPage_wrapper}>
                <div className={styles.searchCleanerPage}>
                    <h2>Замовлення</h2>

                    <TriangleStepper
                        currentStep={currentStep}
                        setCurrentStep={setCurrentStep}
                        isOrder={isOrder}
                    />

                    <div className={styles.searchCleanerPage_cleanersList}>
                        <SearchBar
                            type={'customer'}
                            page={1}
                            setPage={null}
                        />

                        <div className={styles.searchCleanerPage_cleanersList_cleaners}>
                            <div className={styles.searchCleanerPage_cleanersList_cleaners_list}>
                                {(cleanerApplicationsByCleaningRequest?.length === 0 && (!(max_price || min_price || searchValue))) &&
                                    <EmptyState
                                        icon={emptyCleanerApplications}
                                        title={'Ми в пошуках ідеального клінера для вас'}
                                        description={'Будь ласка, зачекайте, поки клінери оберуть ваше замовлення. Сторінка оновиться автоматично, коли будуть доступні пропозиції.'}
                                    />}

                                {(cleanerApplicationsByCleaningRequest?.length === 0 && (max_price || min_price || searchValue)) &&
                                    <EmptyState
                                        icon={emptyFilteredItems}
                                        title={'За вашим запитом результатів не знайдено'}
                                        description={'Ми не змогли знайти результатів за вашими критеріями. Спробуйте змінити ваш запит.'}
                                    />}

                                {cleanerApplicationsByCleaningRequest?.map((application, index) =>
                                    <CleanerBioShort
                                        key={index}
                                        application={application}
                                    />)}
                            </div>
                        </div>
                    </div>

                    {/* to appear hot toast notification */}
                    <Toaster/>
                </div>
            </div>
    );
};

export default SearchCleanerPage;
